import { useState } from "react";

const iosSteps = [
  "Diese Seite in Safari öffnen (wichtig: nur Safari kann das, nicht Chrome).",
  "Unten auf das Teilen-Symbol tippen (Viereck mit Pfeil nach oben).",
  "Im Menü nach unten scrollen und „Zum Home-Bildschirm“ antippen.",
  "Namen bestätigen und oben rechts auf „Hinzufügen“ tippen.",
];

const androidSteps = [
  "Diese Seite in Chrome öffnen (am zuverlässigsten; Firefox funktioniert teils auch).",
  "Oben rechts auf das Drei-Punkte-Menü tippen.",
  "„Zum Startbildschirm hinzufügen“ bzw. „App installieren“ antippen.",
  "Im Dialog auf „Hinzufügen“ bzw. „Installieren“ tippen.",
];

export function InstallGuide({ onClose }: { onClose: () => void }) {
  const [platform, setPlatform] = useState<"ios" | "android">("ios");
  const steps = platform === "ios" ? iosSteps : androidSteps;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Anleitung: App zum Homescreen hinzufügen"
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-end justify-center bg-ink-900/40 sm:items-center sm:p-6"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="animate-fade-up w-full max-w-md rounded-t-3xl bg-chalk-50 p-6 shadow-2xl sm:rounded-3xl"
      >
        <div className="flex items-center justify-between">
          <h2 className="font-display text-xl font-semibold text-turf-900">App aufs Handy holen</h2>
          <button
            type="button"
            aria-label="Schließen"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-full text-ink-400 hover:bg-chalk-200"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-5 w-5">
              <path d="M6 6l12 12M18 6 6 18" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <p className="mt-1 text-sm text-ink-600">
          Einmal einrichten, danach wie eine normale App auf dem Homescreen – schneller Zugriff, auch offline nutzbar.
        </p>

        <div className="mt-4 grid grid-cols-2 gap-1 rounded-xl bg-chalk-200/70 p-1">
          <button
            type="button"
            onClick={() => setPlatform("ios")}
            className={`h-10 rounded-lg text-sm font-medium transition-all ${
              platform === "ios" ? "bg-white text-turf-800 shadow-sm" : "text-ink-600"
            }`}
          >
            iPhone (iOS)
          </button>
          <button
            type="button"
            onClick={() => setPlatform("android")}
            className={`h-10 rounded-lg text-sm font-medium transition-all ${
              platform === "android" ? "bg-white text-turf-800 shadow-sm" : "text-ink-600"
            }`}
          >
            Android
          </button>
        </div>

        <ol className="mt-4 space-y-3">
          {steps.map((step, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="marker-badge mt-0.5 h-6 w-6 flex-shrink-0 border-0 bg-turf-100 text-xs text-turf-700">
                {i + 1}
              </span>
              <span className="text-sm leading-relaxed text-ink-900">{step}</span>
            </li>
          ))}
        </ol>

        <button
          type="button"
          onClick={onClose}
          className="mt-6 h-11 w-full rounded-xl bg-turf-700 text-sm font-semibold text-chalk-50"
        >
          Verstanden
        </button>
      </div>
    </div>
  );
}
